import React from "react";
import {columnDefinition} from "./columnDefinition";
import TableRow from "./TableRow";
import "./CurrentOfferingsTable.scss";
import TranslateComponent from "../../misc/translate/Translate.component";
import {NO_DATA} from "../constants/NewCurrentOfferings";

export default function CurrentOfferingsTable({
  data,
  onSort,
  sortingColumn,
  currentLanguage,
}) {

  let currentNoteSubType = "";
  let hasNoteSubTypeChanged = false;

  return (
    <div className="table-container">
      <table className="offerings-table">
        <thead>
          <tr>
            {columnDefinition.map(({languageCode, key, className}) => (
              <th key={key} onClick={() => onSort(key)} className={className ? className : ""}>
                <div className="header-container">
                  <span className="header-text">
                    <TranslateComponent label={languageCode} />
                  </span>
                  {sortingColumn === key ? (
                    <span className="td-icon td-icon-all sort-icon"></span>
                  ) : (
                    <span className="td-icon td-icon-sort sort-icon"></span>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data && data?.length === 0 ? (
            <tr>
              <td colSpan={columnDefinition.length} className="no-data">
                <TranslateComponent label={NO_DATA} />
              </td>
            </tr>
          ) : (
              data?.map((row, i) => {
                    if (row.noteSubType !== currentNoteSubType) {
                      currentNoteSubType = row.noteSubType;
                      hasNoteSubTypeChanged = true;
                    } else {
                      hasNoteSubTypeChanged = false;
                    }

                    return <TableRow rowData={row} currentLanguage={currentLanguage} currentNoteSubType={hasNoteSubTypeChanged ? currentNoteSubType : null}/>
                  }
              )
          )}
        </tbody>
      </table>
    </div>
  );
}
